import { Fragment } from "react";
import { useTranslation } from "react-i18next";

import AdvancedReportPage from "pstat-anywhere/components/pages/reports/AdvancedReportPage";
import { withLabelContext } from "pstat-anywhere/context_providers/LabelContext";
import titleCase from "pstat-anywhere/utils/titleCase";
import { Button } from "pstat-design-system/shared/Button";

const TemplateManagement = ({
  location,
  variables,
  route,
  router,
  systemDocumentTemplates,
  labels
}) => {
  const { t } = useTranslation();
  const tabs = [
    {
      id: "system_templates_manage",
      textKey: "systemDocumentTemplates.tab",
      path: ""
    }
  ];
  return (
    <AdvancedReportPage
      variables={variables}
      data={systemDocumentTemplates?.systemDocumentTemplates}
      route={route}
      router={router}
      location={location}
      tabs={tabs}
      headerText={t("systemDocumentTemplates.header", {
        documentLabel: titleCase(labels.documentLabel)
      })}
      renderHeader={() => (
        <Button
          id="create-new-template"
          buttonStyle="secondary"
          onClick={() => console.log("create new template")}
        >
          {t("systemDocumentTemplates.createButton")}
        </Button>
      )}
      noContentMessage={t("systemDocumentTemplates.emptyMessage")}
      showTabsPanel={true}
      tableType={"manageTemplates"}
      showPagination={true}
      customOnRow={() => {}}
      frozenColumnTable={true}
      showActionButtonPanel={true}
      renderActionPanel={selectedSitePks => (
        <Fragment>
          {selectedSitePks.length > 1 ? (
            <Button buttonStyle="danger">
              {t("systemDocumentTemplates.deleteButton")}
            </Button>
          ) : (
            <Fragment>
              <Button buttonStyle="danger" mr={1}>
                {t("systemDocumentTemplates.deleteButton")}
              </Button>
              <Button buttonStyle="primary">
                {t("systemDocumentTemplates.editButton")}
              </Button>
            </Fragment>
          )}
        </Fragment>
      )}
      singularSelectedActionsLabel={t("systemDocumentTemplates.template")}
      pluralSelectedActionsLabel={t("systemDocumentTemplates.templates")}
    />
  );
};

export default withLabelContext(TemplateManagement);
